

































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

import Assets from '@/constants/assets';
import Constants from '@/constants/constants';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

import UtilsService from '@/core/services/utils.service';

@Component({
  components: {
    Icon,
  },
})
export default class SearchAutocomplete extends Vue {
  @Prop() private placeholder!: string;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop() private options!: any[];
  @Prop() private optionText!: string;
  @Prop({ default: 15 }) private limit!: number;
  @Prop({ default: () => ({}) }) private optionFields!: any;
  @Model('change', { type: String, default: '' })
  readonly content!: string;

  @Watch('options')
  private watchOptions(newVal: any, oldVal: any) {
    if (this.content !== '' && !this.disabled) {
      this.isOpen = true;
    }
  }
  @Watch('content')
  private watchContent(newVal: any, oldVal: any) {
    if (this.content === '') {
      this.clearInput();
    }
  }

  private isOpen = false;
  private hasOptionSelected = false;
  private inputTimeout!: any;
  private inputEmitTime = Constants.searchEmitTime;

  mounted() {
    if (this.optionText) {
      this.selectOption({ text: this.optionText });
    }
  }

  get syncContent() {
    return this.content;
  }

  set syncContent(val) {
    this.$emit('change', val);
  }

  get iconToShow() {
    let icon = IconEnum.Search;
    if (this.isOpen || this.hasOptionSelected) {
      icon = IconEnum.Close;
    }
    return icon;
  }

  get optionsToDisplay() {
    let result = this.options;
    if (result.length > this.limit) {
      result = this.options.splice(0, this.limit);
    }
    return UtilsService.parseToObject(this.optionFields, result);
  }

  private handleInput() {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.isOpen = false;
      this.hasOptionSelected = false;
      this.$emit('input', this.content);
    }, this.inputEmitTime);
  }

  private clearInput() {
    this.syncContent = '';
    this.isOpen = false;
    this.hasOptionSelected = false;
    this.$emit('search-autocomplete-clear-input');
  }

  private selectOption(option: any) {
    this.$emit('change', option.text);
    this.isOpen = false;
    this.hasOptionSelected = true;
    this.$emit('selected-option', option);
  }
}
